(() => {
  const MOBILE_MAX = 979;
  const MAX_FRAMES = 4; // 1..4

  function prepReveal(reveal) {
    const firstFrame = reveal.querySelector(':scope > .box-ratio');
    let hiddenFrames = Array.from(reveal.querySelectorAll(':scope > .hidden'));

    if (!firstFrame || hiddenFrames.length < 1) return null;

    // only 3 hidden => total 4 frames
    hiddenFrames = hiddenFrames.slice(0, MAX_FRAMES - 1);

    reveal.style.position = 'relative';

    // keep first in flow for height
    firstFrame.style.position = 'relative';
    firstFrame.style.zIndex = '1';
    firstFrame.style.transition = 'opacity 200ms ease';
    firstFrame.style.opacity = '1';

    hiddenFrames.forEach(h => {
      h.style.display = 'block'; // theme might set display:none
      h.style.position = 'absolute';
      h.style.inset = '0';
      h.style.zIndex = '2';
      h.style.transition = 'opacity 200ms ease';
      h.style.opacity = '0';
      h.style.visibility = 'hidden';
      h.style.pointerEvents = 'none';

      const box = h.querySelector('.box-ratio');
      if (box) {
        box.style.position = 'absolute';
        box.style.inset = '0';
        box.style.height = '100%';
        box.style.paddingBottom = '0';
      }
    });

    const framesCount = 1 + hiddenFrames.length;
    let idx = 0;

    function show(newIdx) {
      idx = newIdx;
      firstFrame.style.opacity = idx === 0 ? '1' : '0';

      hiddenFrames.forEach((h, i) => {
        const on = idx === i + 1;
        h.style.opacity = on ? '1' : '0';
        h.style.visibility = on ? 'visible' : 'hidden';
      });
    }

    return { framesCount, show, get idx() { return idx; } };
  }

  function bind() {
    document.querySelectorAll('.prod-image').forEach(card => {
      if (card.dataset.mobileArrowBound === '1') return;
      card.dataset.mobileArrowBound = '1';

      const btn = card.querySelector('.mobile-image-next');
      const reveal = card.querySelector('.reveal');
      if (!btn || !reveal) return;

      const state = prepReveal(reveal);
      if (!state) {
        btn.style.display = 'none';
        return;
      }

      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (window.innerWidth > MOBILE_MAX) return;

        const nextIdx = (state.idx + 1) % state.framesCount; // 1->2->3->4->1
        state.show(nextIdx);
      });
    });
  }

document.addEventListener('shopify:section:load', bind);

// ✅ Re-bind for AJAX injected sections (recommendations)
const observeAndRebind = () => {
  let t = null;

  const scheduleBind = () => {
    if (t) return;
    t = setTimeout(() => {
      t = null;
      bind();
    }, 150);
  };

  const obs = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.addedNodes && m.addedNodes.length) {
        scheduleBind();
        break;
      }
    }
  });

  obs.observe(document.body, { childList: true, subtree: true });
};

document.addEventListener('DOMContentLoaded', () => {
  bind();
  observeAndRebind();

  // Extra re-tries por si recommendations aparece un poco después
  setTimeout(bind, 500);
  setTimeout(bind, 1500);
});
})();